import React from "react";
import AuthGuard from "./AuthGuard";
import BidderAnalyticsDashboard from "app/pages/Report/BidderAnalyticsDashboard";
import PublisherAnalyticsDashboard from "app/pages/Report/PublisherAnalyticsDashboard";
import AdvertiserAnalyticsDashboard from "app/pages/Report/AdvertiserAnalyticsDashboard";
import AdvertiserSupplyDashboard from "app/pages/Report/AdvertiserSupplyDashboard";
import BidderSupplyDashboard from "app/pages/Report/BidderSupplyDashboard";

const CreateCompany = React.lazy(() =>
  import("../pages/SystemConfiguration/CreateCompany")
);
const ManageCompanies = React.lazy(() =>
  import("../pages/SystemConfiguration/ManageCompanies")
);

const CreateAccount = React.lazy(() =>
  import("../pages/SystemConfiguration/CreateAccount")
);
const ManageAccounts = React.lazy(() =>
  import("../pages/SystemConfiguration/ManageAccounts")
);

const CreatePublisher = React.lazy(() =>
  import("../pages/SystemConfiguration/CreatePublisher")
);
const ManagePublishers = React.lazy(() =>
  import("../pages/SystemConfiguration/ManagePublishers")
);

const CreateUser = React.lazy(() =>
  import("../pages/SystemConfiguration/CreateUser")
);
const ManageUsers = React.lazy(() =>
  import("../pages/SystemConfiguration/ManageUsers")
);

//creating multiple with same route because need to trigger refresh.

const SupplyAnalysis = React.lazy(() =>
  import("../components/supplyAnalysis/SupplyAnalysisList")
);

const CreateSupplyAnalysis = React.lazy(() =>
  import("../pages/SystemConfiguration/CreateSupplyAnalysis")
);

const PrivateMarketPlace = React.lazy(() =>
  import("../pages/AudienceManagement/TargetingPage")
);

const DemandPartners = React.lazy(() =>
  import("../pages/AudienceManagement/TargetingPage")
);

// const Campaigns = React.lazy(() =>
//   import("../pages/AudienceManagement/TargetingPage")
// );
const CreateCampaign = React.lazy(() =>
  import("../pages/SystemConfiguration/CreateCampaign")
);
const CampaignsList = React.lazy(() =>
  import("../components/campaigns/CampaignsList")
);
const CreateRole = React.lazy(() =>
  import("../pages/SystemConfiguration/CreateRole")
);
const ManageRoles = React.lazy(() =>
  import("../pages/SystemConfiguration/ManageRoles")
);
const CreateDashboardUserRole = React.lazy(() =>
  import("../pages/SystemConfiguration/CreateDashboardUserRoles")
);
const ManageDashboardUserRoles = React.lazy(() =>
  import("../pages/SystemConfiguration/ManageDashboardUserRoles")
);
const CreateTheme = React.lazy(() =>
  import("../pages/SystemConfiguration/CreateTheme")
);
const ManageThemes = React.lazy(() =>
  import("../pages/SystemConfiguration/ManageThemes")
);

const ManageSupplyDeals = React.lazy(() =>
  import("../pages/SystemConfiguration/ManageSupplyDeals")
);
const CreateSupplyDeal = React.lazy(() =>
  import("../pages/SystemConfiguration/CreateSupplyDeal")
);

const CreateTargetingGroup = React.lazy(() =>
  import("../pages/CampaignManagement/CreateTargetingGroup")
);
const ManageTargetingGroups = React.lazy(() =>
  import("../pages/CampaignManagement/ManageTargetingGroups")
);
const CreatePayments = React.lazy(() =>
  import("../pages/SystemConfiguration/CreatePayment")
);
const CreateDemandPartner = React.lazy(() =>
  import("../pages/SystemConfiguration/CreateDemandPartner")
);
const ManageDemandPartners = React.lazy(() =>
  import("../pages/SystemConfiguration/ManageDemandPartners")
);

const BidderDeliveryReport = React.lazy(() =>
  import("../pages/home/DeliveryReport")
);

const PublisherDeliveryReport = React.lazy(() =>
  import("../pages/home/PublisherDeliveryReport")
);

const AdvertiserDeliveryReport = React.lazy(() =>
  import("../pages/home/Reporting")
);

const PaymentHistory = React.lazy(() =>
  import("app/components/payments/PaymentHistory")
);
const ManagePrivateMarketPlace = React.lazy(() =>
  import("../pages/SystemConfiguration/ManagePrivateMarketPlace")
);

const CreatePrivateMarketPlace = React.lazy(() =>
  import("../pages/SystemConfiguration/CreatePrivateMarketPlace")
);
const ManageRequestSamples = React.lazy(() =>
  import("../pages/SystemConfiguration/ManageRequestSamples")
);
const BidderRequestSamples = React.lazy(() =>
  import("../pages/SystemConfiguration/BidderRequestSamples")
);

const AnalyticsDashboard = React.lazy(() =>
  import("../pages/Report/AnalyticsDashboard")
);
const SupplyDashboard = React.lazy(() =>
  import("../pages/Report/SupplyDashboard")
);

const SystemRoutes = [
  {
    path: "system/createcompany",
    element: (
      <AuthGuard>
        <CreateCompany />
      </AuthGuard>
    ),
  },
  {
    path: "system/editcompany/:id",
    element: (
      <AuthGuard>
        <CreateCompany />
      </AuthGuard>
    ),
  },
  {
    path: "system/managecompanies",
    element: (
      <AuthGuard>
        <ManageCompanies />
      </AuthGuard>
    ),
  },
  {
    path: "system/createaccount",
    element: (
      <AuthGuard>
        <CreateAccount />
      </AuthGuard>
    ),
  },
  {
    path: "system/editaccount/:id",
    element: (
      <AuthGuard>
        <CreateAccount />
      </AuthGuard>
    ),
  },
  {
    path: "system/manageaccounts",
    element: (
      <AuthGuard>
        <ManageAccounts />
      </AuthGuard>
    ),
  },

  {
    path: "publisher/createpublisher",
    element: (
      <AuthGuard>
        <CreatePublisher />
      </AuthGuard>
    ),
  },
  {
    path: "publisher/editpublisher/:id",
    element: (
      <AuthGuard>
        <CreatePublisher />
      </AuthGuard>
    ),
  },
  {
    path: "publisher/managepublishers",
    element: (
      <AuthGuard>
        <ManagePublishers />
      </AuthGuard>
    ),
  },
  {
    path: "publisher/responsesample",
    element: (
      <AuthGuard>
        <ManageRequestSamples />
      </AuthGuard>
    ),
  },
  {
    path: "publisher/reporting",
    element: (
      <AuthGuard>
        <PublisherDeliveryReport />
      </AuthGuard>
    ),
  },
  {
    path: "bidder/createdemandpartner",
    element: (
      <AuthGuard>
        <CreateDemandPartner />
      </AuthGuard>
    ),
  },
  {
    path: "bidder/editdemandpartner/:id",
    element: (
      <AuthGuard>
        <CreateDemandPartner />
      </AuthGuard>
    ),
  },
  {
    path: "bidder/managedemandpartners",
    element: (
      <AuthGuard>
        <ManageDemandPartners />
      </AuthGuard>
    ),
  },
  {
    path: "bidder/reporting",
    element: (
      <AuthGuard>
        <BidderDeliveryReport />
      </AuthGuard>
    ),
  },
  {
    path: "advertiser/reporting",
    element: (
      <AuthGuard>
        <AdvertiserDeliveryReport />
      </AuthGuard>
    ),
  },
  {
    path: "bidder/createprivatemarketplace",
    element: (
      <AuthGuard>
        <CreatePrivateMarketPlace />
      </AuthGuard>
    ),
  },
  {
    path: "bidder/editprivatemarketplace/:id",
    element: (
      <AuthGuard>
        <CreatePrivateMarketPlace />
      </AuthGuard>
    ),
  },
  {
    path: "bidder/manageprivatemarketplace",
    element: (
      <AuthGuard>
        <ManagePrivateMarketPlace />
      </AuthGuard>
    ),
  },

  {
    path: "bidder/responsesample",
    element: (
      <AuthGuard>
        <BidderRequestSamples />
      </AuthGuard>
    ),
  },
  {
    path: "system/createuser",
    element: (
      <AuthGuard>
        <CreateUser />
      </AuthGuard>
    ),
  },
  {
    path: "system/edituser/:id",
    element: (
      <AuthGuard>
        <CreateUser />
      </AuthGuard>
    ),
  },
  {
    path: "system/manageusers",
    element: (
      <AuthGuard>
        <ManageUsers />
      </AuthGuard>
    ),
  },
  {
    path: "targeting/supplyanalysis",
    element: (
      <AuthGuard>
        <SupplyAnalysis />
      </AuthGuard>
    ),
  },
  {
    path: "targeting/createsupplyanalysis",
    element: (
      <AuthGuard>
        <CreateSupplyAnalysis />
      </AuthGuard>
    ),
  },
  {
    path: "targeting/editsupplyanalysis/:id",
    element: (
      <AuthGuard>
        <CreateSupplyAnalysis />
      </AuthGuard>
    ),
  },
  {
    path: "targeting/privatemarketplace",
    element: (
      <AuthGuard>
        <PrivateMarketPlace />
      </AuthGuard>
    ),
  },
  {
    path: "targeting/demandpartners",
    element: (
      <AuthGuard>
        <DemandPartners />
      </AuthGuard>
    ),
  },
  // {
  //   path: "targeting/campaigns",
  //   element: (
  //     <AuthGuard>
  //       <Campaigns />
  //     </AuthGuard>
  //   ),
  // },
  {
    path: "targeting/createcampaign",
    element: (
      <AuthGuard>
        <CreateCampaign />
      </AuthGuard>
    ),
  },
  {
    path: "targeting/editcampaign/:id",
    element: (
      <AuthGuard>
        <CreateCampaign />
      </AuthGuard>
    ),
  },
  {
    path: "targeting/reactivatecampaign/:id",
    element: (
      <AuthGuard>
        <CreateCampaign />
      </AuthGuard>
    ),
  },
  {
    path: "targeting/campaigns",
    element: (
      <AuthGuard>
        <CampaignsList />
      </AuthGuard>
    ),
  },
  {
    path: "advertiser/analyticsdashboard",
    element: (
      <AuthGuard>
        <AdvertiserAnalyticsDashboard />
      </AuthGuard>
    ),
  },
  {
    path: "advertiser/analyticsdashboard/:campaignIds",
    element: (
      <AuthGuard>
        <AdvertiserAnalyticsDashboard />
      </AuthGuard>
    ),
  },
  {
    path: "bidder/analyticsdashboard",
    element: (
      <AuthGuard>
        <BidderAnalyticsDashboard />
      </AuthGuard>
    ),
  },
  {
    path: "publisher/analyticsdashboard",
    element: (
      <AuthGuard>
        <PublisherAnalyticsDashboard />
      </AuthGuard>
    ),
  },

  {
    path: "advertiser/supplydashboard",
    element: (
      <AuthGuard>
        <AdvertiserSupplyDashboard />
      </AuthGuard>
    ),
  },
  {
    path: "bidder/supplydashboard",
    element: (
      <AuthGuard>
        <BidderSupplyDashboard />
      </AuthGuard>
    ),
  },

  {
    path: "system/createrole",
    element: (
      <AuthGuard>
        <CreateRole />
      </AuthGuard>
    ),
  },
  {
    path: "system/editrole/:id",
    element: (
      <AuthGuard>
        <CreateRole />
      </AuthGuard>
    ),
  },
  {
    path: "system/manageroles",
    element: (
      <AuthGuard>
        <ManageRoles />
      </AuthGuard>
    ),
  },
  {
    path: "system/createdashboarduserrole",
    element: (
      <AuthGuard>
        <CreateDashboardUserRole />
      </AuthGuard>
    ),
  },
  {
    path: "system/editdashboarduserrole/:id",
    element: (
      <AuthGuard>
        <CreateDashboardUserRole />
      </AuthGuard>
    ),
  },
  {
    path: "system/managedashboarduserroles",
    element: (
      <AuthGuard>
        <ManageDashboardUserRoles />
      </AuthGuard>
    ),
  },
  {
    path: "system/createtheme",
    element: (
      <AuthGuard>
        <CreateTheme />
      </AuthGuard>
    ),
  },
  {
    path: "system/edittheme/:id",
    element: (
      <AuthGuard>
        <CreateTheme />
      </AuthGuard>
    ),
  },
  {
    path: "system/managethemes",
    element: (
      <AuthGuard>
        <ManageThemes />
      </AuthGuard>
    ),
  },
  {
    path: "publisher/supplydeals",
    element: (
      <AuthGuard>
        <ManageSupplyDeals />
      </AuthGuard>
    ),
  },
  {
    path: "publisher/createsupplydeal",
    element: (
      <AuthGuard>
        <CreateSupplyDeal />
      </AuthGuard>
    ),
  },
  {
    path: "publisher/editsupplydeal/:id",
    element: (
      <AuthGuard>
        <CreateSupplyDeal />
      </AuthGuard>
    ),
  },
  {
    path: "targeting/targetinggroups",
    element: (
      <AuthGuard>
        <ManageTargetingGroups />
      </AuthGuard>
    ),
  },
  {
    path: "targeting/createtgroup",
    element: (
      <AuthGuard>
        <CreateTargetingGroup />
      </AuthGuard>
    ),
  },
  {
    path: "targeting/edittgroup/:id",
    element: (
      <AuthGuard>
        <CreateTargetingGroup />
      </AuthGuard>
    ),
  },
  {
    path: "payments/addpayment",
    element: (
      <AuthGuard>
        <CreatePayments />
      </AuthGuard>
    ),
  },
  {
    path: "payments/paymenthistory",
    element: (
      <AuthGuard>
        <PaymentHistory />
      </AuthGuard>
    ),
  },

  {
    path: "report/analyticsdashboard",
    element: (
      <AuthGuard>
        <AnalyticsDashboard />
      </AuthGuard>
    ),
  },
  {
    path: "report/supplydashboard",
    element: (
      <AuthGuard>
        <SupplyDashboard />
      </AuthGuard>
    ),
  },
];

export default SystemRoutes;
